import React, {Component} from "react";
import {connect} from "react-redux";

import * as handlers from "../../../constants/handlers";
import * as serverActions from "../../../actions/serverActions";

import AddDatabasePanelComponent from "../../../components/scenes/incompatible/AddDatabasePanel";
import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";

class AddDatabasePanel extends Component {
    render() {
        return (
            <AddDatabasePanelComponent
                activeServer={this.props.activeServer}
                databaseList={this.props.databaseList}
                loading={this.props.loading}
                installDatabaseExe={this.props.dispatchInstallDatabaseExeAction}
                installDatabaseZip={this.props.dispatchInstallDatabaseZipAction}
                openDatabaseFromExcelModal={this.props.dispatchOpenDatabaseFromExcelModal}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeServer: store.server.activeServer,
        databaseList: store.server.databaseList,
        loading: store.server.requests.some(
            (request) =>
                request.method === handlers.INSTALL_DATABASE_FILE_EXCEL ||
                request.method === handlers.INSTALL_DATABASE_FILE_EXE ||
                request.method === handlers.INSTALL_DATABASE_FILE_ZIP
        )
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchInstallDatabaseExeAction: (path) => {
            dispatch(serverActions.installDatabaseExe(path));
        },
        dispatchInstallDatabaseZipAction: (path) => {
            dispatch(serverActions.installDatabaseZip(path));
        },
        dispatchOpenDatabaseFromExcelModal: () => {
            dispatch(
                navigationActions.openModal(componentTypes.MODAL_NO_TAB, componentTypes.DATABASE_FROM_EXCEL_MODAL)
            );
        }
    };
};

export default AddDatabasePanel = connect(mapStoreToProps, mapDispatchToProps)(AddDatabasePanel);
